import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import { Box, Button } from "@chakra-ui/react";
import { useEffect, useState } from "react";

interface PaginateNavigateProps {
  pages_preview: any[];
  pageSelect?: any;
  current_page: number;
  lastPage?: number;
}

export function PaginateNavigate({
  pages_preview,
  pageSelect,
  current_page,
  lastPage,
}: PaginateNavigateProps) {
  // Garantindo que current_page não seja menor que 1 e não ultrapasse lastPage
  const safeCurrentPage = Math.max(
    1,
    Math.min(current_page, lastPage || current_page)
  );

  const [currentPage, setCurrentPage] = useState(safeCurrentPage);

  useEffect(() => {
    setCurrentPage(safeCurrentPage);
  }, [safeCurrentPage]);

  const handlePageSelect = (value: any) => {
    const pageNumber = Number(value);
    setCurrentPage(pageNumber);
    if (pageSelect) {
      pageSelect(pageNumber);
    }
  };

  const handleClick = (value: any) => {
    let pageNumber;
    if (value === 'prev') {
      pageNumber = currentPage - 1;
    } else if (value === 'next') {
      pageNumber = currentPage + 1;
    } else {
      pageNumber = Number(value);
    }
    handlePageSelect(pageNumber);
  };

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDir="row"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
      >
        {pages_preview?.map((data, index) => {
          const isPreviousButton = index === 0;
          const isNextButton = data.label === "Next &raquo;";
          const isDisabled =
            data.active ||
            (isPreviousButton && currentPage === 1) ||
            (isNextButton && currentPage === lastPage);

          let value: any;
          if (isPreviousButton) {
            value = 'prev';
          } else if (isNextButton) {
            value = 'next';
          } else {
            value = data.label;
          }

          return (
            <Button
              isDisabled={isDisabled}
              margin={1}
              padding={3}
              key={index}
              onClick={() => handleClick(value)}
            >
              {isPreviousButton ? (
                <ArrowLeftIcon />
              ) : isNextButton ? (
                <ArrowRightIcon />
              ) : (
                data.label
              )}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
}
